// extracted by mini-css-extract-plugin
export default {"root":"MediakitV2_root__7S8vn"};